import { parseQueryString, stringifyQueryString } from '@fv/models/core'

export function stringify(args: { [key: string]: any }) {
  args = args || {}
  let result = ''
  let added = 0

  Object.keys(args).forEach(key => {
    const value = args[key]
    let kvp = null

    if (typeof value !== 'undefined') {
      kvp = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`

      if (added === 0) result += '?'
      else result += '&'

      result += kvp
      added++
    }
  })

  return result
}

export { parseQueryString, stringifyQueryString }
